// ==============================================
// ================Import Actions================
// ==============================================

import {
  TOGGLE_ADVANCED_SEARCH,
  SET_RADIUS_VALUE,
  SET_ACCORDION_EXPANDED,
  TOGGLE_BACKGROUND_IMAGE,
  SET_LOADING_MAP,
  SET_MAP_RESULTS,
  SET_MARKERS_COLOR,
  SET_DATA_GRID_ROWS,
  SET_DATA_AVAILABLE,
  SET_GREATER_LAT,
  SET_LESS_LAT,
  SAVED_DATA_GRID_ROWS,
  SET_SAVE_LAYER,
  SET_SAVE_RECTANGLE_BOUNDS,
  SET_SAVE_RECTANGLE_NORTH,
  SET_SAVE_RECTANGLE_SOUTH,
  SET_SAVE_RECTANGLE_EAST,
  SET_SAVE_RECTANGLE_WEST,
  SET_VALUE_CHANGE,
  SET_SAVE_CIRCLE_LAT,
  SET_SAVE_CIRCLE_LON,
  SET_SAVE_CIRCLE,
  SET_OPENTOUR,
  SET_OPEN_POPPER,
  SET_SAVE_NETWORK_CLICKED,
  SET_TOOLS_CHECKBOX,
  SET_NETWORKS_ARRAY,
  TOGGLE_NETWORKS_MENU,
  SET_CLICK_ON_NETWORKS,
  SET_SELECT_ALL_CLICK,
  SET_SELECT_INACTIVE,
  SAVE_RECEIVER_LIST,
  SAVE_ANTENNA_LIST,
  SAVE_RADOME_LIST,
  SAVE_FILE_TYPE_LIST,
  SAVE_RECEIVER_TYPE_SELECTED,
  SAVE_ANTENNA_TYPE_SELECTED,
  SAVE_RADOME_TYPE_SELECTED,
  SAVE_SATELLITE_SYSTEM_SELECTED,
  SET_DATE_PICKER_ADVANCED_SEARCH_DATE_FROM,
  SET_DATE_PICKER_ADVANCED_SEARCH_DATE_TO,
  SET_DATA_AVAILABILITY,
  SET_DAILY_OBSERVATION,
  SET_FILE_TYPE_SELECTED,
  SET_FILE_STATUS_SELECTED,
  SET_OBSERVATIONS_TYPES,
  SET_FREQUENCIES_BAND,
  SET_ATTRIBUTE_CHANNEL,
  SET_SATELLITE_SYSTEM_QC,
  SET_EPOCH_QC,
  SET_ELEVATION_QC,
  SET_MULTIPATH_QC,
  SET_CYCLE_QC,
  SET_SINGLE_POINT_QC,
  SET_CLOCK_QC,
  SET_PARAMS,
  SET_LOADING_CHART,
  SET_POLYGON_VALUE,
  SET_GREATER_LON,
  SET_LESS_LON,
  SET_GREATER_ALT,
  SET_LESS_ALT,
  SET_GREATER_INSTALL_DATE,
  SET_LESS_INSTALL_DATE,
  SET_GREATER_END_DATE,
  SET_LESS_END_DATE,
  SAVE_PAGES_LIST,
  SAVE_MARKER_GRID_FILTER,
  SAVE_SITE_NAME_GRID_FILTER,
  SAVE_COUNTRY_GRID_FILTER,
  SAVE_STATE_GRID_FILTER,
  SAVE_CITY_GRID_FILTER,
  SAVE_AGENCY_GRID_FILTER,
  SAVE_NETWORK_GRID_FILTER,
  SET_CLEAR_BUTTON,
  SAVE_STRING_TO_CLIPBOARD,
  EXPORT_CSV,
  SAVE_BACKEND_POPUP,
  SET_OPEN_BACKEND_MODAL,
  SAVE_INVERTED_NETWORK,
  SAVE_CELL_MOUSE_OVER_MARKER,
  SAVE_CELL_MOUSE_OUT_MARKER,
  SET_SELECT_ALL,
  SET_SAVE_COUNTRY_QUERY,
  SET_NEW_SLUG_QUERY,
  TOGGLE_SELECTED_MARKER,
} from '../actions/site';

// ==============================================
// ================InitialState==================
// ==============================================

const initialState = {
  // nameApplication: 'gnssdata-epos.oca.eu',
  allPages: [],
  backendPopupData: {},
  openBackendModal: false,
  map: {
    center: [51.505, -0.09],
    miniatureBackground: false,
    loadingMap: true,
    mapResults: false,
    roadMap: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
    satelliteMap: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    mapURL: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
  },
  advancedSearch: {
    chartLoading: false,
    isOpen: false,
    expanded: 'panel1',
    receiverList: [],
    antennaList: [],
    radomeList: [],
    fileTypeList: [],
    satelliteSystem: [{
      name: 'GPS',
    }, {
      name: 'GLONASS',
    }, {
      name: 'GALILEO',
    }, {
      name: 'BEIDOU',
    }, {
      name: 'SBAS',
    }, {
      name: 'IRNSS',
    }, {
      name: 'QZSS',
    }],
    satelliteSystemT3: [{
      name: 'GPS',
    }, {
      name: 'GLONASS',
    }, {
      name: 'GALILEO',
    }, {
      name: 'BEIDOU',
    }, {
      name: 'SBAS',
    }, {
      name: 'IRNSS',
    }, {
      name: 'QZSS',
    }],
    typeOfSignal: [{
      name: 'P/C',
    }, {
      name: 'L',
    }, {
      name: 'D',
    }, {
      name: 'S',
    }],
    frequencies: [{
      name: '1',
    }, {
      name: '2',
    }, {
      name: '5',
    }, {
      name: '6',
    }, {
      name: '7',
    }, {
      name: '8',
    }, {
      name: '9',
    }],
    chanel: [{
      name: 'No Attr',
    }, {
      name: 'P',
    }, {
      name: 'D',
    }, {
      name: 'Y',
    }, {
      name: 'M',
    }, {
      name: 'N',
    }, {
      name: 'A',
    }, {
      name: 'B',
    }, {
      name: 'C',
    }, {
      name: 'I',
    }, {
      name: 'Q',
    }, {
      name: 'S',
    }, {
      name: 'L',
    }, {
      name: 'X',
    }, {
      name: 'W',
    }, {
      name: 'Z',
    }],
    statusFile: [{
      name: '1',
    }, {
      name: '2',
    }, {
      name: '3',
    }],
    statusTitle: '1 = OK;  2 = Small inconsistency in rinex header;  3 = QC metrics not optimal wrt expected',
    statusNodeFile: [{
      name: '-3',
    }, {
      name: '-2',
    }, {
      name: '-1',
    }, {
      name: '0',
    }, {
      name: '1',
    }, {
      name: '2',
    }, {
      name: '3',
    }],
    statusNodeTitle: '-3=T3 metadata incompliant with T1 metadata (alternatively not populated to DB!);-2=QC running not successful;-1=QC running;0=File not checked;1=File checked – OK according to the T1/T2/T3 metadata;2=File checked – small inconsistency in RINEX header;3=File checked – warning flag based on hardwired QC metrics (optional?)',
    equipement: {
      receiverType: [],
      antennaType: [],
      radomeType: [],
      satelliteSystem: [],
    },
    fileInfo: {
      dateFrom: '',
      dateTo: '',
      dataAvailability: '',
      dailyObservation: '',
      fileType: [],
      fileStatus: [],
    },
    QCFileInfo: {
      observationsTypes: [],
      frequenciesBand: [],
      attributeChannel: [],
      satelliteSystem: [],
      epoch: '',
      elevation: '',
      multipath: '',
      cycle: '',
      singlePoint: '',
      clock: '',
    },
    params: '',
  },

  markersColors: [],

  dataGrid: {
    dataGridRows: [],
    savedDataGridRows: [],
  },
  data: {
    dataAvailable: true,
  },
  filter: {
    marker: '',
    siteName: '',
    greaterLat: '',
    lessLat: '',
    greaterLon: '',
    lessLon: '',
    greaterAlt: '',
    lessAlt: '',
    greaterInstallDate: '',
    lessInstallDate: '',
    greaterEndDate: '',
    lessEndDate: '',
    country: '',
    state: '',
    city: '',
    agency: '',
    network: '',
    invertedNetwork: '',
    countryQuery: [],
  },
  useMap: {
    savedLayer: {},
    rectangle: {
      valueChange: false,
      North: '',
      South: '',
      East: '',
      West: '',
    },
    circle: {
      lat: '',
      lon: '',
      radius: 0,
    },
    polygon: '',
  },
  joyride: {
    openTour: false,
  },
  popper: {
    openPopper: false,
    networkClicked: [],
    networkNameStation: '',
  },
  networks: {
    openNetworksMenu: false,
    tools: [{ name: 'select all', checked: true }, { name: 'inactive', checked: true }],
    listNetworks: [],
    networkClick: false,
    selectAllClick: false,
    selectInactive: false,
  },
  clear: false,
  stringToClipboard: '',
  exportCsv: false,
  cellMouseOver: {},
  cellMouseOut: {},
  selectAll: false,
  newSlugQuery: '',
  selectedMarkers: [],
};

// ==============================================
// ===================Reducer====================
// ==============================================

function siteReducer(state = initialState, action = {}) {
  switch (action.type) {
    case TOGGLE_ADVANCED_SEARCH:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          isOpen: !state.advancedSearch.isOpen,
        },

      };
    case SET_RADIUS_VALUE:
      return {
        ...state,
        useMap: {
          ...state.useMap,
          circle: {
            ...state.useMap.circle,
            radius: action.value,
          },
        },
      };
    case SET_ACCORDION_EXPANDED:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          expanded: action.panel,
        },
      };
    case TOGGLE_BACKGROUND_IMAGE:
      return {
        ...state,
        map: {
          ...state.map,
          miniatureBackground: !state.map.miniatureBackground,
          mapURL: (state.map.miniatureBackground) ? state.map.roadMap : state.map.satelliteMap,
        },
      };
    case TOGGLE_NETWORKS_MENU:
      return {
        ...state,
        networks: {
          ...state.networks,
          openNetworksMenu: !state.networks.openNetworksMenu,
        },
      };
    case SET_LOADING_MAP:
      return {
        ...state,
        map: {
          ...state.map,
          loadingMap: action.loadingMapValue,
        },
      };
    case SET_MAP_RESULTS:
      return {
        ...state,
        map: {
          ...state.map,
          mapResults: action.mapResults,
        },
      };
    case SET_MARKERS_COLOR:
      return {
        ...state,
        markersColors: action.value,
      };
    case SET_DATA_GRID_ROWS:
      return {
        ...state,
        dataGrid: {
          ...state.dataGrid,
          dataGridRows: action.value,
        },
      };
    case SET_DATA_AVAILABLE:
      return {
        ...state,
        data: {
          ...state.data,
          dataAvailable: action.value,
        },
      };
    case SET_GREATER_LAT:
      return {
        ...state,
        filter: {
          ...state.filter,
          greaterLat: action.value,
        },
      };
    case SET_LESS_LAT:
      return {
        ...state,
        filter: {
          ...state.filter,
          lessLat: action.value,
        },
      };
    case SET_GREATER_LON:
      return {
        ...state,
        filter: {
          ...state.filter,
          greaterLon: action.value,
        },
      };
    case SET_LESS_LON:
      return {
        ...state,
        filter: {
          ...state.filter,
          lessLon: action.value,
        },
      };
    case SET_GREATER_ALT:
      return {
        ...state,
        filter: {
          ...state.filter,
          greaterAlt: action.value,
        },
      };
    case SET_LESS_ALT:
      return {
        ...state,
        filter: {
          ...state.filter,
          lessAlt: action.value,
        },
      };
    case SET_GREATER_INSTALL_DATE:
      return {
        ...state,
        filter: {
          ...state.filter,
          greaterInstallDate: action.value,
        },
      };
    case SET_LESS_INSTALL_DATE:
      return {
        ...state,
        filter: {
          ...state.filter,
          lessInstallDate: action.value,
        },
      };
    case SET_GREATER_END_DATE:
      return {
        ...state,
        filter: {
          ...state.filter,
          greaterEndDate: action.value,
        },
      };
    case SET_LESS_END_DATE:
      return {
        ...state,
        filter: {
          ...state.filter,
          lessEndDate: action.value,
        },
      };
    case SAVED_DATA_GRID_ROWS:
      return {
        ...state,
        dataGrid: {
          ...state.dataGrid,
          savedDataGridRows: action.value,
        },
      };
    case SET_SAVE_LAYER:
      return {
        ...state,
        useMap: {
          ...state.useMap,
          savedLayer: action.value,
        },
      };
    case SET_SAVE_RECTANGLE_BOUNDS:
      return {
        ...state,
        useMap: {
          ...state.useMap,
          rectangle: {
            ...state.useMap.rectangle,
            North: action.valueNorth,
            South: action.valueSouth,
            East: action.valueEast,
            West: action.valueWest,
          },
        },
      };
    case SET_SAVE_RECTANGLE_NORTH:
      return {
        ...state,
        useMap: {
          ...state.useMap,
          rectangle: {
            ...state.useMap.rectangle,
            North: action.value,
          },
        },
      };
    case SET_SAVE_RECTANGLE_SOUTH:
      return {
        ...state,
        useMap: {
          ...state.useMap,
          rectangle: {
            ...state.useMap.rectangle,
            South: action.value,
          },
        },
      };
    case SET_SAVE_RECTANGLE_EAST:
      return {
        ...state,
        useMap: {
          ...state.useMap,
          rectangle: {
            ...state.useMap.rectangle,
            East: action.value,
          },
        },
      };
    case SET_SAVE_RECTANGLE_WEST:
      return {
        ...state,
        useMap: {
          ...state.useMap,
          rectangle: {
            ...state.useMap.rectangle,
            West: action.value,
          },
        },
      };
    case SET_VALUE_CHANGE:
      return {
        ...state,
        useMap: {
          ...state.useMap,
          rectangle: {
            ...state.useMap.rectangle,
            valueChange: action.value,
          },
        },
      };
    case SET_SAVE_CIRCLE_LAT:
      return {
        ...state,
        useMap: {
          ...state.useMap,
          circle: {
            ...state.useMap.circle,
            lat: action.value,
          },
        },
      };
    case SET_SAVE_CIRCLE_LON:
      return {
        ...state,
        useMap: {
          ...state.useMap,
          circle: {
            ...state.useMap.circle,
            lon: action.value,
          },
        },
      };
    case SET_SAVE_CIRCLE:
      return {
        ...state,
        useMap: {
          ...state.useMap,
          circle: {
            ...state.useMap.circle,
            lat: action.valueLat,
            lon: action.valueLng,
            radius: action.valueRadius,
          },
        },
      };
    case SET_OPENTOUR:
      return {
        ...state,
        joyride: {
          ...state.joyride,
          openTour: action.value,
        },
      };
    case SET_OPEN_POPPER:
      return {
        ...state,
        popper: {
          ...state.popper,
          openPopper: action.value,
        },
      };
    case SET_SAVE_NETWORK_CLICKED:
      return {
        ...state,
        popper: {
          ...state.popper,
          networkClicked: action.value,
          networkNameStation: action.name,
        },
      };
    case SET_TOOLS_CHECKBOX:
      return {
        ...state,
        networks: {
          ...state.networks,
          tools: action.value,
        },
      };
    case SET_NETWORKS_ARRAY:
      return {
        ...state,
        networks: {
          ...state.networks,
          listNetworks: action.networks,
        },
      };
    case SET_CLICK_ON_NETWORKS:
      return {
        ...state,
        networks: {
          ...state.networks,
          networkClick: action.value,
        },
      };
    case SET_SELECT_ALL_CLICK:
      return {
        ...state,
        networks: {
          ...state.networks,
          selectAllClick: action.value,
        },
      };
    case SET_SELECT_INACTIVE:
      return {
        ...state,
        networks: {
          ...state.networks,
          selectInactive: action.value,
        },
      };
    case SAVE_RECEIVER_LIST:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          receiverList: action.value,
        },
      };
    case SAVE_ANTENNA_LIST:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          antennaList: action.value,
        },
      };
    case SAVE_RADOME_LIST:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          radomeList: action.value,
        },
      };
    case SAVE_FILE_TYPE_LIST:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          fileTypeList: action.value,
        },
      };
    case SAVE_RECEIVER_TYPE_SELECTED:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          equipement: {
            ...state.advancedSearch.equipement,
            receiverType: action.value,
          },
        },
      };
    case SAVE_ANTENNA_TYPE_SELECTED:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          equipement: {
            ...state.advancedSearch.equipement,
            antennaType: action.value,
          },
        },
      };
    case SAVE_RADOME_TYPE_SELECTED:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          equipement: {
            ...state.advancedSearch.equipement,
            radomeType: action.value,
          },
        },
      };
    case SAVE_SATELLITE_SYSTEM_SELECTED:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          equipement: {
            ...state.advancedSearch.equipement,
            satelliteSystem: action.value,
          },
        },
      };
    case SET_DATE_PICKER_ADVANCED_SEARCH_DATE_FROM:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          fileInfo: {
            ...state.advancedSearch.fileInfo,
            dateFrom: action.value,
          },
        },
      };
    case SET_DATE_PICKER_ADVANCED_SEARCH_DATE_TO:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          fileInfo: {
            ...state.advancedSearch.fileInfo,
            dateTo: action.value,
          },
        },
      };
    case SET_DATA_AVAILABILITY:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          fileInfo: {
            ...state.advancedSearch.fileInfo,
            dataAvailability: action.value,
          },
        },
      };
    case SET_DAILY_OBSERVATION:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          fileInfo: {
            ...state.advancedSearch.fileInfo,
            dailyObservation: action.value,
          },
        },
      };
    case SET_FILE_TYPE_SELECTED:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          fileInfo: {
            ...state.advancedSearch.fileInfo,
            fileType: action.value,
          },
        },
      };
    case SET_FILE_STATUS_SELECTED:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          fileInfo: {
            ...state.advancedSearch.fileInfo,
            fileStatus: action.value,
          },
        },
      };
    case SET_OBSERVATIONS_TYPES:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          QCFileInfo: {
            ...state.advancedSearch.QCFileInfo,
            observationsTypes: action.value,
          },
        },
      };
    case SET_FREQUENCIES_BAND:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          QCFileInfo: {
            ...state.advancedSearch.QCFileInfo,
            frequenciesBand: action.value,
          },
        },
      };
    case SET_ATTRIBUTE_CHANNEL:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          QCFileInfo: {
            ...state.advancedSearch.QCFileInfo,
            attributeChannel: action.value,
          },
        },
      };
    case SET_SATELLITE_SYSTEM_QC:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          QCFileInfo: {
            ...state.advancedSearch.QCFileInfo,
            satelliteSystem: action.value,
          },
        },
      };
    case SET_EPOCH_QC:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          QCFileInfo: {
            ...state.advancedSearch.QCFileInfo,
            epoch: action.value,
          },
        },
      };
    case SET_ELEVATION_QC:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          QCFileInfo: {
            ...state.advancedSearch.QCFileInfo,
            elevation: action.value,
          },
        },
      };
    case SET_MULTIPATH_QC:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          QCFileInfo: {
            ...state.advancedSearch.QCFileInfo,
            multipath: action.value,
          },
        },
      };
    case SET_CYCLE_QC:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          QCFileInfo: {
            ...state.advancedSearch.QCFileInfo,
            cycle: action.value,
          },
        },
      };
    case SET_SINGLE_POINT_QC:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          QCFileInfo: {
            ...state.advancedSearch.QCFileInfo,
            singlePoint: action.value,
          },
        },
      };
    case SET_CLOCK_QC:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          QCFileInfo: {
            ...state.advancedSearch.QCFileInfo,
            clock: action.value,
          },
        },
      };
    case SET_PARAMS:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          params: action.value,
        },
      };
    case SET_LOADING_CHART:
      return {
        ...state,
        advancedSearch: {
          ...state.advancedSearch,
          chartLoading: action.loadingChartValue,
        },
      };
    case SET_POLYGON_VALUE:
      return {
        ...state,
        useMap: {
          ...state.useMap,
          polygon: action.value,
        },
      };
    case SAVE_PAGES_LIST:
      return {
        ...state,
        allPages: action.value,
      };
    case SAVE_MARKER_GRID_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          marker: action.value,
        },
      };
    case SAVE_SITE_NAME_GRID_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          siteName: action.value,
        },
      };
    case SAVE_COUNTRY_GRID_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          country: action.value,
        },
      };
    case SAVE_STATE_GRID_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          state: action.value,
        },
      };
    case SAVE_CITY_GRID_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          city: action.value,
        },
      };
    case SAVE_AGENCY_GRID_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          agency: action.value,
        },
      };
    case SAVE_NETWORK_GRID_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          network: action.value,
        },
      };
    case SAVE_INVERTED_NETWORK:
      return {
        ...state,
        filter: {
          ...state.filter,
          invertedNetwork: action.value,
        },
      };
    case SET_CLEAR_BUTTON:
      return {
        ...state,
        clear: action.value,
      };
    case SAVE_STRING_TO_CLIPBOARD:
      return {
        ...state,
        stringToClipboard: action.value,
      };
    case EXPORT_CSV:
      return {
        ...state,
        exportCsv: action.value,
      };
    case SAVE_BACKEND_POPUP:
      return {
        ...state,
        backendPopupData: action.value,
      };
    case SET_OPEN_BACKEND_MODAL:
      return {
        ...state,
        openBackendModal: action.value,
      };
    case SAVE_CELL_MOUSE_OVER_MARKER:
      return {
        ...state,
        cellMouseOver: action.value,
      };
    case SAVE_CELL_MOUSE_OUT_MARKER:
      return {
        ...state,
        cellMouseOut: action.value,
      };
    case SET_SELECT_ALL:
      return {
        ...state,
        selectAll: action.value,
      };
    case SET_SAVE_COUNTRY_QUERY:
      return {
        ...state,
        filter: {
          ...state.filter,
          countryQuery: action.value,
        },
      };
    case SET_NEW_SLUG_QUERY:
      return {
        ...state,
        newSlugQuery: action.value,
      };
    case TOGGLE_SELECTED_MARKER: {
      const already = state.selectedMarkers.includes(action.markerName);
      return {
        ...state,
        selectedMarkers: already
          ? state.selectedMarkers.filter((n) => n !== action.markerName)
          : [...state.selectedMarkers, action.markerName],
      };
    }

    default:
      return state;
  }
}

export default siteReducer;
